import React from 'react';

const PrivacyTerms = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-4">
        <h1 className="fw-bold">TeeBlanka - Terms & Conditions</h1>
        <p className="text-muted">
          Effective Date: 01.04.2025<br />          
          Brand Name: <strong>Tee Blanka®</strong> (A brand under Jain Screen®)
        </p>
      </div>

      {/* Terms & Conditions */}
      <section className="mb-5">
        <h3 className="mb-3 border-bottom pb-2">Terms & Conditions</h3>
        <div className="mb-4">
          <h5>1. Eligibility</h5>
          <p>You must be at least 18 years old to use this website. By using this site, you warrant that you are legally able to enter into a binding contract.</p>
        </div>
        <div className="mb-4">
          <h5>2. Products & Services</h5>
          <p>All products listed on www.teeblanka.com are subject to availability. We reserve the right to modify, suspend, or discontinue any product or service at any time without notice.</p>
        </div>
        <div className="mb-4">
          <h5>3. Pricing & Payments</h5>
          <p>Prices displayed are in Indian Rupees (INR) and include applicable taxes unless stated otherwise. Payments are securely processed via trusted third-party payment gateways.</p>
        </div>
        <div className="mb-4">
          <h5>4. Shipping & Delivery</h5>
          <p>We ship across India. Delivery timelines are estimates. We are not liable for delays caused by third-party courier services or unforeseen circumstances.</p>
        </div>
        <div className="mb-4">
          <h5>5. Returns & Refunds</h5>
          <p>Please refer to our separate <a href='/refund-policy'>Return & Refund Policy</a>. Custom-made items are non-returnable unless defective or damaged.</p>
        </div>
        <div className="mb-4">
          <h5>6. User Data & Privacy</h5>
          <ul>
            <li>We collect your personal information solely for order processing, communication, and website improvement.</li>
            <li>Payment data is processed via secure gateways; we do not store sensitive card information.</li>
            <li>Your data is protected by encryption and used in compliance with Indian data protection laws.</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>7. Intellectual Property & Image Copyright</h5>
          <ul>
            <li>All content is the exclusive property of Tee Blanka®, except logos and images used for display purposes.</li>
            <li>Unauthorized use, reproduction, or distribution is strictly prohibited.</li>
            <li>For image copyright issues, contact: <a href="mailto:support@teeblanka.com">support@teeblanka.com</a></li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>8. Limitation of Liability</h5>
          <p>Tee Blanka® is not liable for indirect or incidental damages arising from the use of our products or website.</p>
        </div>
        <div className="mb-4">
          <h5>9. Governing Law</h5>
          <p>These terms are governed by the laws of India. Disputes shall be settled in courts located in Sangli, Maharashtra.</p>
        </div>
        <div className="mb-4">
          <h5>10. Modifications</h5>
          <p>We reserve the right to update or change these Terms & Conditions at any time. Continued use implies acceptance.</p>
        </div>
        <div className="mb-4">
          <h5>11. Contact Information</h5>
          <p>Email: <a href="mailto:admin@teeblanka.com">admin@teeblanka.com</a><br />Phone: +91 93722 12922</p>
        </div>
        <div className="mb-4">
          <h5>12. Wholesale / B2B Buyers</h5>
          <ul>
            <li>Wholesale pricing is available for verified business clients.</li>
            <li>Valid GST number and registration proof are mandatory.</li>
            <li>MOQ and timelines depend on order size and customization.</li>
            <li>B2B sales are non-returnable unless defective.</li>
            <li>Contact: <a href="mailto:b2b@teeblanka.com">b2b@teeblanka.com</a></li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>13. Reseller Policy</h5>
          <ul>
            <li>Resale under Tee Blanka® name requires written consent.</li>
            <li>White-labeled options available for bulk orders.</li>
            <li>Unauthorized resale or brand misuse may result in legal action.</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>14. Digital Downloads</h5>
          <ul>
            <li>Any downloadable content is for personal or licensed business use.</li>
            <li>Redistribution or resale is strictly prohibited.</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>15. Social Media Usage Rights</h5>
          <ul>
            <li>By tagging us or using our branded hashtags, you grant us permission to share your content for promotional purposes.</li>
            <li>You can request takedown by emailing <a href="mailto:support@teeblanka.com">support@teeblanka.com</a></li>
          </ul>
        </div>
      </section>

      {/* Privacy Policy */}
      <section className="mb-5">
        <h3 className="mb-3 border-bottom pb-2">Privacy Policy</h3>
        <div className="mb-4">
          <h5>1. What We Collect</h5>
          <ul>
            <li>Personal info (Name, Contact, Address)</li>
            <li>Browser & device data for analytics</li>
            <li>No sensitive card info is stored</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>2. Usage</h5>
          <ul>
            <li>To process orders & customer service</li>
            <li>To improve user experience</li>
            <li>For promotional communication (optional)</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>3. Data Protection</h5>
          <ul>
            <li>SSL encryption and secure storage practices</li>
            <li>Access limited to authorized personnel</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>4. Third-Party Sharing</h5>
          <ul>
            <li>Only with payment gateways and logistics partners</li>
            <li>Never sold to external parties</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>5. Cookies</h5>
          <ul>
            <li>Used for personalization & analytics</li>
            <li>You can disable cookies in your browser settings</li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>6. Your Rights</h5>
          <ul>
            <li>You may request access or deletion of your data</li>
            <li>Email: <a href="mailto:privacy@teeblanka.com">privacy@teeblanka.com</a></li>
          </ul>
        </div>
        <div className="mb-4">
          <h5>7. Updates</h5>
          <p>Policy is reviewed regularly. Last updated on 10.07.2025</p>
        </div>
      </section>

      <div className="text-center text-muted">
        <p>Thank you for shopping with <strong>Tee Blanka®</strong>!</p>
      </div>
    </div>
  );
};

export default PrivacyTerms;
